<template>
  <RexModalV3
    :show="showWindow"
    :enableFooter="true"
    width="85rem"
    @onClose="onWindowHide"
    :centered="true"
  >
    <template #header>
      <div class="cloud-win-empty-header"></div>
    </template>
    <template #body>
      <div class="d-flex flex-column">
        <div class="d-flex">
          <div class="box">
            <img :src="loadImg(templates.icon)" />
          </div>
          <div>
            <h1 class="svc-name">
              {{ templates.title }}
            </h1>
            <h4 class="sub-title">
              {{ templates.subtitle }}
            </h4>
            <p>
              {{ templates.desc }}
            </p>
          </div>
        </div>
        <div class="d-flex upload-box">
          <div>
            <h4>{{ $t('addProject') }}</h4>
            <p class="mb-0">
              {{
                $t(
                  'aws.add-a-servicename-service-account-project-by-uploading-the-projects-private-key-file',
                  [serviceName],
                )
              }}
            </p>
          </div>
          <div class="btn-container">
            <input
              @click="clearFile('file-upload')"
              id="file"
              ref="file-upload"
              type="file"
              @change="onAddSelection('file-upload', '')"
              class="input-box"
              accept=".json"
            />
            <RexButtonV3
              @onClick="openExplorer('file-upload')"
              variant="primary"
              id="cloud-integration-upload"
            >
              {{ $t('aws.upload-private-key-file') }}
            </RexButtonV3>
          </div>
        </div>
        <div class="d-flex flex-column project-container">
          <div
            v-for="(project, index) in projects"
            class="d-flex project-item"
            :key="'project-container-' + index"
          >
            <div>
              <span class="project-title">
                {{ $t('aws.project-id') }}
                <span class="project-name">
                  {{ project.name }}
                </span>
              </span>
              <!-- <p class="mb-0">Client email: tarun.rawat@rakuten.com</p> -->
            </div>
            <div class="btn-container">
              <input
                @click="clearFile(`file-edit`, index)"
                :id="`file-${index}`"
                :ref="`file-edit`"
                type="file"
                @change="onEditSelection(`file-edit`, index, project.cpId)"
                class="input-box"
                accept=".json"
              />
              <BaseIcon
                name="editFilled"
                height="2rem"
                iconColor="#f59600"
                @click="
                  () => {
                    openExplorer(`file-edit`, index);
                  }
                "
              ></BaseIcon>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="cloud-win-modal-footer">
        <RexButtonV3
          id="cloud-uninstall-btn"
          @onClick="uninstall"
          variant="default"
          class="cloud-win-uninstall-btn"
        >
          {{ $t('aws.uninstall-integration') }}
        </RexButtonV3>
      </div>
    </template>
  </RexModalV3>
</template>
<script>
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import RexButtonV3 from '@/rex-components/RexButtonV3.vue';
import { config } from './util';

import { importImg } from '@/utils/helper-function';
import { mapActions, mapState } from 'vuex';
import BaseIcon from '@/rex-components/BaseIcon.vue';
export default {
  components: { RexModalV3, RexButtonV3, BaseIcon },
  methods: {
    onWindowHide() {
      this.showWindow = false;
      this.$emit('onClose');
    },
    uninstall() {
      this.$emit('onUninstall', this.serviceName);
    },
    clearFile(ref, index) {
      if (index === undefined) this.$refs[ref].value = null;
      else this.$refs[ref][index].value = null;
    },
    importImg,
    loadImg(imgName, type = 'img') {
      if (imgName === undefined) return;
      return require(`../../../assets/img/${imgName}`);
    },
    openExplorer(ref, index) {
      if (index === undefined) this.$refs[ref].click();
      else this.$refs[ref][index].click();
    },
    updateProject() {},
    onEditSelection(ref, index, cpId) {
      const file = this.$refs[ref][index].files[0];
      const formdata = new FormData();
      formdata.append('file', file);
      const data = {
        cpId,
      };
      formdata.append('data', JSON.stringify(data));
      this.$emit('editProject', formdata, this.serviceName);
    },
    onAddSelection(ref) {
      const file = this.$refs[ref].files[0];
      const formdata = new FormData();
      formdata.append('file', file);
      const data = {
        cloudVendor: this.serviceName,
      };
      formdata.append('data', JSON.stringify(data));
      this.$emit('uploadProject', formdata, this.serviceName);
    },
  },
  data() {
    return {
      showWindow: true,
      templates: config.INSTALL_WINDOW[this.serviceName],
    };
  },
  props: {
    serviceName: { type: String, default: 'GCP' },
    projects: { type: Array, default: () => [] },
  },
};
</script>
<style lang="scss" scoped>
.box {
  padding: 1rem;
  margin: 1rem;
}
.svc-name {
  font-size: 2rem !important;
}
.sub-title,
.svc-name {
  padding-bottom: 0.5rem;
}
.btn-container {
  align-self: center;
}
.upload-box,
.project-item {
  justify-content: space-between;
  background-color: $bg-secondary;
  padding: 1rem;
  border-radius: 0.8rem;
}
.project-container {
  padding-right: 1rem;
}
.upload-box {
  margin-right: 1rem;
}

.project-container {
  margin-top: 2rem;
  overflow: auto;
  max-height: 10rem;
}
.project-item {
  margin-top: 1rem;
}
.project-name,
.project-title {
  font-size: 1.2rem;
}
.project-name {
  font-weight: bold;
}
// .project-container::-webkit-scrollbar-thumb{
//      background:#aab3f4 !important;
//     border-radius: 0.25rem;
//      opacity: 0.26;
// }

.footer {
  width: 100%;
  display: flex;
}
.input-box {
  display: none;
}
.cloud-win-empty-header {
  height: 1.5rem;
}
.cloud-win-uninstall-btn {
  width: fit-content;
}
.cloud-win-modal-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
